var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InclusionCaseStudiesDetail.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3d05f568\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InclusionCaseStudiesDetail.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/landings/InclusionCaseStudiesDetail.vue
// module id = 1480
// module chunks = 0